import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ActivityService } from '../../services/activity.service';
import { CompanyService } from '../../services/company.service';
import { CompanyInvoiceService } from '../../services/companyinvoice.service';
import { ContactService } from '../../services/contact.service';
import { getCustomFieldSchemas, initializeCustomFields, makeTableCustomFields } from '../../utils/CustomFieldEntities/custom-field-utils';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const recordData = writable(null);
export const stats = writable(null);
export const ownerships = writable([]);
export const comments = writable([]);
export const activities = writable([]);
export const channels = writable([]);
export const companyContacts = writable([]);
export const companyContact = writable({});
export const newContact = writable({});
export const customFieldsSchemas = writable([]);
export const tableCustomFields = writable([]);
export const contactCustomFieldsSchemas = writable([]);
export const companyInvoicesSemaphore = writable("");
export const companyInvoicesDashboard = writable([]);
export const companyInvoices = writable([]);
export const companyInvoice = writable({});
export const newInvoice = writable({});
export const filter_invoice = writable({ criteria: {} });
export const pagination_invoices = writable(null);
export const companyInvoicesEmails = writable([]);
export const filter_invoiceemails = writable({ criteria: {} });
export const pagination_invoicesemails = writable(null);
let issupplier = false;
export async function initList() {
    issupplier = window.location.pathname.indexOf("supplier") >= 0;
    filter.set({ criteria: { clfCompanyTypeId: (issupplier ? 'F' : 'C') }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    recordData.set(null);
    await loadCustomFieldSchemas();
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    recordData.set(null);
    stats.set(null);
    comments.set([]);
    activities.set([]);
    ownerships.set([]);
    channels.set([]);
    companyContacts.set([]);
    companyInvoicesDashboard.set([]);
    companyInvoicesSemaphore.set('success');
    companyInvoices.set([]);
    companyInvoicesEmails.set([]);
    filter_invoice.set({ criteria: {}, params: null, sorting: "" });
    pagination_invoices.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    filter_invoiceemails.set({ criteria: {}, params: null, sorting: "" });
    pagination_invoicesemails.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await loadCustomFieldSchemas();
    await loadContactCustomFieldSchemas();
    if (oid == 0) {
        let tmpRecord = { oid: 0 };
        tmpRecord.customFields = initializeCustomFields(get(customFieldsSchemas));
        record.set(tmpRecord);
        let tmpRecordData = { oid: 0 };
        recordData.set(tmpRecordData);
    }
    else {
        let _resp = await CompanyService.fetchCompany(oid).toPromise();
        record.set(_resp.payload);
        let _resp1 = await CompanyService.fetchCompanyData(oid).toPromise();
        recordData.set(_resp1.payload);
        await loadStats(oid);
        await loadActivities(oid);
        await loadChannels(oid);
        await loadContacts(oid);
        await loadOwnerships(oid);
        await loadInvoicesDashboard(oid);
        await loadInvoices(oid);
        await loadInvoicesEmails(oid);
    }
}
async function loadCustomFieldSchemas() {
    let schemas = await getCustomFieldSchemas("COMPANYXXX");
    customFieldsSchemas.set(schemas);
    let tcf = await makeTableCustomFields(schemas, 'company');
    tableCustomFields.set(tcf);
}
async function loadStats(customerOid) {
    // let _resp = await CompanyService.fetchCompanyStats(customerOid).toPromise();
    // stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function clearSearch() {
    resetSearchFilter();
    search();
}
export function resetSearchFilter() {
    issupplier = window.location.pathname.indexOf("supplier") >= 0;
    filter.set({ criteria: { clfCompanyTypeId: (issupplier ? 'F' : 'C') }, params: null, sorting: "" });
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await CompanyService.getCompanies(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    if (issupplier)
        navigate(`/supplier/0`);
    else
        navigate(`/company/0`);
}
export function onEdit(item) {
    if (issupplier)
        navigate(`/supplier/${item.oid}`);
    else
        navigate(`/company/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return CompanyService.saveCompany(_record).toPromise();
}
export async function saveData() {
    let _recordMain = get(record);
    let _record = get(recordData);
    if (_record.oid == 0)
        _record.oid = _recordMain.oid;
    return CompanyService.saveCompanyData(_record).toPromise();
}
export async function onDelete(item) {
    await CompanyService.deleteCompany(item.oid).toPromise();
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
// ----------------------------------------------------------------------
// Activities
// ----------------------------------------------------------------------
export async function loadActivities(companyId) {
    let _resp = await ActivityService.getOpenActivities(companyId, 'Company').toPromise();
    activities.set(_resp.payload);
}
export async function addActivity(event) {
    let act = event.detail;
    await ActivityService.saveActivity(act).toPromise();
    loadActivities(act.entityId);
}
export async function completeActivity(event) {
    let act = event.detail;
    await ActivityService.completeActivity(act.oid).toPromise();
    loadActivities(act.entityId);
}
// ----------------------------------------------------------------------
// Comments
// ----------------------------------------------------------------------
export async function loadComments(companyId) {
    /*let _resp = await CompanyService.getCompanyComments(companyId).toPromise();
    comments.set(_resp.payload);*/
}
export async function addComment(event) {
    /*let comment: ICommentDTO = event.detail;
    await CompanyService.saveCompanyComment(comment).toPromise();
    loadComments(comment.entityId);*/
}
export async function delComment(event) {
    /*let comment: ICommentDTO = event.detail;
    await CompanyService.deleteCompanyComment(comment.oid).toPromise();
    loadComments(comment.entityId);*/
}
// ----------------------------------------------------------------------
// Channels
// ----------------------------------------------------------------------
export async function loadChannels(companyId) {
    let _resp = await CompanyService.getCompanyChannels(companyId).toPromise();
    channels.set(_resp.payload);
}
export async function addChannel(event) {
    let channel = event.detail;
    await CompanyService.saveCompanyChannel(channel).toPromise();
    loadChannels(channel.entityId);
}
export async function delChannel(event) {
    let channel = event.detail;
    await CompanyService.deleteCompanyChannel(channel.oid).toPromise();
    loadChannels(channel.entityId);
}
// ----------------------------------------------------------------------
// Contacts
// ----------------------------------------------------------------------
export async function loadContacts(companyId) {
    let _resp = await CompanyService.getCompanyContacts(companyId).toPromise();
    companyContacts.set(_resp.payload);
}
export async function saveContact(item) {
    let _company = get(record);
    let _record = get(companyContact);
    _record.companyId = _company.oid;
    return CompanyService.saveCompanyContact(_record).toPromise();
}
export async function onDeleteContact(item) {
    await CompanyService.deleteCompanyContact(item.oid).toPromise();
    await loadContacts(item.companyContact.companyId);
}
export async function createNewContact(item) {
    let _company = get(record);
    let _respContact = await ContactService.saveContact(item).toPromise();
    if (_respContact.issue.error)
        return;
    let _record = {
        oid: 0,
        contactId: _respContact.payload.oid,
        companyId: _company.oid,
        mainCompany: 0
    };
    return CompanyService.saveCompanyContact(_record).toPromise();
}
async function loadContactCustomFieldSchemas() {
    let schemas = await getCustomFieldSchemas("CONTACTXXX");
    contactCustomFieldsSchemas.set(schemas);
}
// ----------------------------------------------------------------------
// Ownership
// ----------------------------------------------------------------------
export async function loadOwnerships(companyId) {
    let _resp = await CompanyService.getCompanyOwnership(companyId).toPromise();
    ownerships.set(_resp.payload);
}
export async function addOwner(event) {
    let comment = event.detail;
    await CompanyService.saveCompanyOwnership(comment).toPromise();
    loadOwnerships(comment.entityId);
}
export async function delOwner(event) {
    let comment = event.detail;
    await CompanyService.deleteCompanyOwnership(comment.oid).toPromise();
    loadOwnerships(comment.entityId);
}
// ----------------------------------------------------------------------
// Invoices
// ----------------------------------------------------------------------
export function onPageChangeInvoice(companyId, pageNumber) {
    pagination_invoices.set(Object.assign(Object.assign({}, get(pagination_invoices)), { currentPage: pageNumber }));
    loadInvoices(companyId);
}
export async function loadInvoicesDashboard(companyId) {
    let _resp = await CompanyInvoiceService.getCompanyInvoicesDashboard(companyId).toPromise();
    var cid = _resp.payload;
    companyInvoicesDashboard.set(cid);
    if (cid != null) {
        var sem = "success";
        cid.forEach(c => {
            if (c.unpaidinvoicesolder > 0)
                sem = "danger";
            else if (c.unpaidinvoicesrecent > 0 && sem != 'danger')
                sem = "warning";
        });
    }
    companyInvoicesSemaphore.set(sem);
}
export async function loadInvoices(companyId) {
    try {
        let _filter_invoice = get(filter_invoice);
        let _pag = get(pagination_invoices);
        let _resp = await CompanyInvoiceService.getCompanyInvoices(companyId, _filter_invoice, _pag.currentPage).toPromise();
        //let _resp = await CompanyService.getCompanies(_filter, _pag.currentPage).toPromise();
        companyInvoices.set(_resp.payload);
        pagination_invoices.set(_resp.pagination);
    }
    finally {
    }
}
export async function searchInvoices(companyId) {
    pagination_invoices.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await loadInvoices(companyId);
    await loadInvoicesDashboard(companyId);
}
export async function createNewInvoice() {
    let _company = get(record);
    let _record = get(companyInvoice);
    _record.invoice.companyId = _company.oid;
    return CompanyInvoiceService.saveCompanyInvoice(_record).toPromise();
}
export async function saveInvoice(item) {
    let _company = get(record);
    let _record = get(companyInvoice);
    _record.invoice.companyId = _company.oid;
    return CompanyInvoiceService.saveCompanyInvoice(_record).toPromise();
}
export async function onDeleteInvoice(item) {
    await CompanyInvoiceService.deleteCompanyInvoice(item.oid).toPromise();
    await loadInvoices(item.invoice.companyId);
    await loadInvoicesDashboard(item.invoice.companyId);
}
export async function sendEmail(invoiceoid, companyid) {
    if (invoiceoid == null) {
        let _record = get(companyInvoice);
        if (_record != null) {
            invoiceoid = _record.oid;
            companyid = _record.invoice.companyId;
        }
    }
    if (invoiceoid != null) {
        await CompanyInvoiceService.sendCompanyInvoiceEmail(invoiceoid).toPromise();
        await loadInvoices(companyid);
    }
}
export async function exportInvoicePdf(invoiceid) {
    CompanyInvoiceService.downloadInvoicePDF(invoiceid);
}
export async function loadInvoicesEmails(companyId) {
    try {
        let _filter_invoice = get(filter_invoiceemails);
        let _pag = get(pagination_invoicesemails);
        _filter_invoice.criteria.companyid = companyId;
        let _resp = await CompanyInvoiceService.getCompanyInvoicesEmails(_filter_invoice, _pag.currentPage).toPromise();
        //let _resp = await CompanyService.getCompanies(_filter, _pag.currentPage).toPromise();
        companyInvoicesEmails.set(_resp.payload);
        pagination_invoicesemails.set(_resp.pagination);
    }
    finally {
    }
}
export function onPageChangeInvoiceEmails(companyId, pageNumber) {
    pagination_invoicesemails.set(Object.assign(Object.assign({}, get(pagination_invoices)), { currentPage: pageNumber }));
    loadInvoicesEmails(companyId);
}
export async function searchInvoicesEmails(companyId) {
    pagination_invoicesemails.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await loadInvoicesEmails(companyId);
}
